import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import { ThemeProvider } from "@/lib/theme";
import AppShell from "@/components/AppShell";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Patients from "@/pages/Patients";
import PatientForm from "@/pages/PatientForm";
import PatientDetail from "@/pages/PatientDetail";
import Clients from "@/pages/Clients";
import ClientDetail from "@/pages/ClientDetail";
import ConsultationForm from "@/pages/ConsultationForm";
import Consultations from "@/pages/Consultations";
import Appointments from "@/pages/Appointments";
import Reports from "@/pages/Reports";
import Reminders from "@/pages/Reminders";
import Admin from "@/pages/Admin";
import Grooming from "@/pages/Grooming";
import GroomingForm from "@/pages/GroomingForm";
import Boarding from "@/pages/Boarding";
import BoardingForm from "@/pages/BoardingForm";
import BusinessReports from "@/pages/BusinessReports";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center text-muted-foreground">
        <div className="animate-pulse">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="bottom-right" richColors />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<Protected><AppShell /></Protected>}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/clients" element={<Clients />} />
              <Route path="/clients/:id" element={<ClientDetail />} />
              <Route path="/patients" element={<Patients />} />
              <Route path="/patients/new" element={<PatientForm />} />
              <Route path="/patients/:id" element={<PatientDetail />} />
              <Route path="/patients/:id/edit" element={<PatientForm />} />
              <Route path="/consultations" element={<Consultations />} />
              <Route path="/consultations/new" element={<ConsultationForm />} />
              <Route path="/consultations/:id/edit" element={<ConsultationForm />} />
              <Route path="/grooming" element={<Grooming />} />
              <Route path="/grooming/new" element={<GroomingForm />} />
              <Route path="/grooming/:id/edit" element={<GroomingForm />} />
              <Route path="/boarding" element={<Boarding />} />
              <Route path="/boarding/new" element={<BoardingForm />} />
              <Route path="/boarding/:id/edit" element={<BoardingForm />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/reports/business" element={<BusinessReports />} />
              <Route path="/appointments" element={<Appointments />} />
              <Route path="/reminders" element={<Reminders />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}
